/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountingBaseQuery,
  AccountingInfoQuery,
  HuiJiFenLuChaXunTiaoJian,
  JiaoYiLiuShuiChaXunTiaoJian,
  JiaoYiLiuShuiChaXunTiaoJian1,
  ResponseApiHuiJiCaoZuoXiangYing,
  ResponseApiIPageHuiJiFenLuXiangYing,
  ResponseApiIPageJiaoYiLiuShuiJiLu,
  ResponseApiIPageJiaoYiLiuShuiJiLu1,
  ResponseApiMeiTiBaoBiaoXiangYing,
  ResponseApiPageAdvertiserAccountDataDTO,
  ResponseApiPingTaiZhangHuYuEXiangYing,
  ResponseApiPingZhengYanZhengXiangYing,
  ResponseApiZhangHuYuEXiangYing,
  YuEChaXunQingQiu,
  YuEChongZhiQingQiu,
  YuEKouJianQingQiu,
  YuETuiKuanQingQiu,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class CaiWuGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name GetAdvertiserSpendDataUsingPost
   * @summary 广告主消耗数据,充值/退款界面
   * @request POST:/dsp-admin/api/accounting/advertiser/data
   * @secure
   */
  getAdvertiserSpendDataUsingPost = (
    infoQuery: AccountingInfoQuery,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiPageAdvertiserAccountDataDTO, void>({
      path: `/dsp-admin/api/accounting/advertiser/data`,
      method: "POST",
      body: infoQuery,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name GetTransactionsUsingPost
   * @summary 查询广告主流水
   * @request POST:/dsp-admin/api/accounting/advertiser/transactions
   * @secure
   */
  getTransactionsUsingPost = (
    查询条件参数: JiaoYiLiuShuiChaXunTiaoJian1,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageJiaoYiLiuShuiJiLu1, void>({
      path: `/dsp-admin/api/accounting/advertiser/transactions`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name GetAdvertiserBalanceUsingPost
   * @summary 查询广告主账户余额,广告主后台使用
   * @request POST:/dsp-admin/api/accounting/balance
   * @secure
   */
  getAdvertiserBalanceUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiZhangHuYuEXiangYing, void>({
      path: `/dsp-admin/api/accounting/balance`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name GetBalanceUsingPost
   * @summary 查询广告主账户余额,运营后台
   * @request POST:/dsp-admin/api/accounting/balance/info
   * @secure
   */
  getBalanceUsingPost = (
    queryDto: YuEChaXunQingQiu,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiZhangHuYuEXiangYing, void>({
      path: `/dsp-admin/api/accounting/balance/info`,
      method: "POST",
      body: queryDto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name DeductUsingPost
   * @summary 扣减广告主余额
   * @request POST:/dsp-admin/api/accounting/deduct
   * @secure
   */
  deductUsingPost = (request: YuEKouJianQingQiu, params: RequestParams = {}) =>
    this.request<ResponseApiHuiJiCaoZuoXiangYing, void>({
      path: `/dsp-admin/api/accounting/deduct`,
      method: "POST",
      body: request,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name GetEntriesUsingPost
   * @summary 查询会计分录列表
   * @request POST:/dsp-admin/api/accounting/entries
   * @secure
   */
  getEntriesUsingPost = (
    查询条件参数: HuiJiFenLuChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageHuiJiFenLuXiangYing, void>({
      path: `/dsp-admin/api/accounting/entries`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name GetPlatformBalanceUsingPost
   * @summary 查询平台总账户余额
   * @request POST:/dsp-admin/api/accounting/platform/balance
   * @secure
   */
  getPlatformBalanceUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiPingTaiZhangHuYuEXiangYing, void>({
      path: `/dsp-admin/api/accounting/platform/balance`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name GetPublisherTransactionsUsingPost
   * @summary 查询媒体流水
   * @request POST:/dsp-admin/api/accounting/publisher/transactions
   * @secure
   */
  getPublisherTransactionsUsingPost = (
    查询条件参数: JiaoYiLiuShuiChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageJiaoYiLiuShuiJiLu, void>({
      path: `/dsp-admin/api/accounting/publisher/transactions`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name RechargeUsingPost
   * @summary 充值广告主余额
   * @request POST:/dsp-admin/api/accounting/recharge
   * @secure
   */
  rechargeUsingPost = (
    request: YuEChongZhiQingQiu,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiHuiJiCaoZuoXiangYing, void>({
      path: `/dsp-admin/api/accounting/recharge`,
      method: "POST",
      body: request,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name RefundUsingPost
   * @summary 退还广告主余额
   * @request POST:/dsp-admin/api/accounting/refund
   * @secure
   */
  refundUsingPost = (request: YuETuiKuanQingQiu, params: RequestParams = {}) =>
    this.request<ResponseApiHuiJiCaoZuoXiangYing, void>({
      path: `/dsp-admin/api/accounting/refund`,
      method: "POST",
      body: request,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name ReportUsingPost
   * @summary 财务报表
   * @request POST:/dsp-admin/api/accounting/report
   * @secure
   */
  reportUsingPost = (
    baseQuery: AccountingBaseQuery,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiMeiTiBaoBiaoXiangYing, void>({
      path: `/dsp-admin/api/accounting/report`,
      method: "POST",
      body: baseQuery,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaiWuGuanLi
   * @name VerifyVoucherUsingPost
   * @summary 验证凭证借贷是否平衡
   * @request POST:/dsp-admin/api/accounting/verify/{voucherNo}
   * @secure
   */
  verifyVoucherUsingPost = (voucherNo?: string, params: RequestParams = {}) =>
    this.request<ResponseApiPingZhengYanZhengXiangYing, void>({
      path: `/dsp-admin/api/accounting/verify/${voucherNo}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new CaiWuGuanLi();
